exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Line-module__line___1AEkS{width:100%;border-top:.2px solid transparent;border-bottom:1.5px solid #787878}", ""]);

// exports
exports.locals = {
	"line": "Line-module__line___1AEkS"
};